<template>
  <div class="page-body-content">
    <div class="features-container">
      <div class="features-header">
        <div class="header-item">
          <h4>Functionality</h4>
        </div>
        <div class="header-item">
          <h4>Status</h4>
        </div>
      </div>

      <div class="features-list" v-if="!isLoadingFeatures">
        <div v-for="(feature, index) in features" :key="index" class="feature-item">
          <div class="feature-info">
            <div class="feature-icon">
              <img :src="getFeatureIcon(feature)" :alt="feature.name" />
            </div>
            <span class="feature-name">{{ feature.name }}</span>
          </div>

          <div class="feature-controls">
            <span class="deactivate-text">Deactivate</span>
            <div class="toggle-switch">
              <input type="checkbox" :id="`toggle-${index}`" v-model="feature.active"
                @change="toggleFeature(feature)" />
              <label :for="`toggle-${index}`" class="switch-label">
                <span class="switch-slider"></span>
              </label>
            </div>
            <span class="status-text" :class="{ active: feature.active }">
              {{ feature.active ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      </div>
      <div class="features-list" v-else>
        <div class="loading-container">
          <div>
            Loading...
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import DropdownButton from "@/components/DropdownButton.vue";
import widgetButton from "@/components/widget/widgetButton.vue";

export default {
  components: {
    DropdownButton,
    widgetButton
  },
  data: () => ({
    planActions: [
      { name: "Manage", value: "manage" },
      { name: "Suspend/Pause", value: "suspend" },
      { name: "Cancel", value: "cancel" }
    ],
    features: [
      {
        name: "Search",
        value: "search",
        icon: require("@/assets/admin-icon/menu/search.svg"),
        iconActive: require("@/assets/admin-icon/menu/search_active.svg"),
        active: false
      },
      {
        name: "Calendar",
        value: "calendar",
        icon: require("@/assets/admin-icon/menu/calendar.svg"),
        iconActive: require("@/assets/admin-icon/menu/calendar_active.svg"),
        active: false
      },
      {
        name: "Dashboard",
        value: "dashboard",
        icon: require("@/assets/admin-icon/menu/dashboard.svg"),
        iconActive: require("@/assets/admin-icon/menu/dashboard_active.svg"),
        active: false
      },
      {
        name: "Tasks",
        value: "tasks",
        icon: require("@/assets/admin-icon/menu/tasks.svg"),
        iconActive: require("@/assets/admin-icon/menu/tasks_active.svg"),
        active: false
      },
      {
        name: "Instructor",
        value: "instructor",
        icon: require("@/assets/admin-icon/menu/instructor.svg"),
        iconActive: require("@/assets/admin-icon/menu/instructor_active.svg"),
        active: false
      },
      {
        name: "Accounts",
        value: "accounts",
        icon: require("@/assets/admin-icon/menu/accounts.svg"),
        iconActive: require("@/assets/admin-icon/menu/accounts_active.svg"),
        active: false
      },
      {
        name: "Signature",
        value: "signature",
        icon: require("@/assets/admin-icon/menu/signature.svg"),
        iconActive: require("@/assets/admin-icon/menu/signature_active.svg"),
        active: false
      },
      {
        name: "School",
        value: "school",
        icon: require("@/assets/admin-icon/menu/school.svg"),
        iconActive: require("@/assets/admin-icon/menu/school_active.svg"),
        active: false
      },
      {
        name: "Internship",
        value: "internship",
        icon: require("@/assets/admin-icon/menu/internship.svg"),
        iconActive: require("@/assets/admin-icon/menu/internship_active.svg"),
        active: false
      },
      {
        name: "Resumes",
        value: "resumes",
        icon: require("@/assets/admin-icon/menu/resumes.svg"),
        iconActive: require("@/assets/admin-icon/menu/resumes_active.svg"),
        active: false
      },
      {
        name: "Pitches",
        value: "pitches",
        icon: require("@/assets/admin-icon/menu/pitches.svg"),
        iconActive: require("@/assets/admin-icon/menu/pitches_active.svg"),
        active: false
      },
      {
        name: "Candidates",
        value: "candidates",
        icon: require("@/assets/admin-icon/menu/candidates.svg"),
        iconActive: require("@/assets/admin-icon/menu/candidates_active.svg"),
        active: false
      },
      {
        name: "Leads",
        value: "leads",
        icon: require("@/assets/admin-icon/menu/leads.svg"),
        iconActive: require("@/assets/admin-icon/menu/leads_active.svg"),
        active: false
      },
      {
        name: "Communication",
        value: "communication",
        icon: require("@//assets/admin-icon/menu/communication.svg"),
        iconActive: require("@/assets/admin-icon/menu/communication-active.svg"),
        active: false
      },
      {
        name: "Reports",
        value: "reports",
        icon: require("@/assets/admin-icon/menu/reports.svg"),
        iconActive: require("@/assets/admin-icon/menu/reports_active.svg"),
        active: false
      },
      {
        name: "Alumni",
        value: "alumni",
        icon: require("@/assets/admin-icon/menu/alumni.svg"),
        iconActive: require("@/assets/admin-icon/menu/alumni_active.svg"),
        active: false
      },
      {
        name: "Matrix",
        value: "matrix",
        icon: require("@/assets/admin-icon/menu/matrix.svg"),
        iconActive: require("@/assets/admin-icon/menu/matrix_active.svg"),
        active: false
      }
    ],
    schoolId: null,
    featuresData: [],
    isLoadingFeatures: false,
  }),
  mounted() {
    let vm = this;
    // Get subscription data
    vm.schoolId = parseInt(this.$route.params.id);
    vm.loadSubscriptionData();
  },
  methods: {
    loadSubscriptionData() {
      // Load subscription data from API
      let vm = this;
      vm.isLoadingFeatures = true;
      vm.$store.dispatch("GET_SUBSCRIPTION_FEATURES_DATA", {
        school_id: vm.schoolId,
        features: vm.features.map(feature => feature.value)
      }).then(response => {
        vm.isLoadingFeatures = false;
        vm.featuresData = response.data;
        // Update features array with subscription data
        if (vm.featuresData && Array.isArray(vm.featuresData)) {
          vm.featuresData.forEach(subscriptionFeature => {
            const featureIndex = vm.features.findIndex(f => f.value === subscriptionFeature.feature);
            if (featureIndex !== -1) {
              vm.features[featureIndex].active = subscriptionFeature.active;
            }
          });
        }
      }).catch(error => {
        console.log(error);
      });
    },
    toggleFeature(feature) {
      console.log(`Toggling ${feature.name}:`, feature.active);
      // Here you would typically make an API call to update the feature status
      this.updateFeatureStatus(feature);
    },
    updateFeatureStatus(feature) {
      // API call to update feature status
      console.log(`Updating feature ${feature.name} to ${feature.active ? 'active' : 'inactive'}`);
      let vm = this;
      vm.$store.dispatch("UPDATE_SUBSCRIPTION_FEATURES_DATA", {
        school_id: vm.schoolId,
        feature_value: feature.value,
        active: feature.active
      }).then(response => {
        console.log(response);
        vm.$notify({
          title: "Success",
          message: "Feature updated successfully",
          type: "success"
        });
      }).catch(error => {
        console.log(error);
      });
    },
    getFeatureIcon(feature) {
      return feature.active ? feature.iconActive : feature.icon;
    },
    handlePlanAction(action) {
      console.log("Plan action:", action);
      switch (action) {
        case "manage":
          this.managePlan();
          break;
        case "suspend":
          this.suspendPlan();
          break;
        case "cancel":
          this.cancelPlan();
          break;
      }
    },
    managePlan() {
      console.log("Managing plan...");
    },
    suspendPlan() {
      console.log("Suspending plan...");
    },
    cancelPlan() {
      console.log("Cancelling plan...");
    }
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
.page-body-content {
  padding: 20px;

  .features-container {
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 50%;

    .features-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 30px;
      background: #f8f9fa;
      border-bottom: 1px solid #e9ecef;

      .header-item {
        h4 {
          margin: 0;
          font-size: 12px;
          font-weight: 600;
          color: #495057;
        }

        &:first-child {
          flex: 1;
        }

        &:last-child {
          min-width: 120px;
          text-align: center;
        }
      }
    }

    .features-list {
      .feature-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        border-bottom: 1px solid #f0f0f0;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f9fa;
        }

        &:last-child {
          border-bottom: none;
        }

        .feature-info {
          display: flex;
          align-items: center;
          flex: 1;

          .feature-icon {
            width: 24px;
            height: 24px;
            margin-right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 20px;
              height: 20px;
              object-fit: contain;
            }
          }

          .feature-name {
            font-size: 12px;
            font-weight: 500;
            color: #333;
          }
        }

        .feature-controls {
          display: flex;
          align-items: center;
          gap: 15px;

          .deactivate-text {
            font-size: 12px;
            color: #6c757d;
            min-width: 80px;
          }

          .toggle-switch {
            position: relative;

            input[type="checkbox"] {
              opacity: 0;
              width: 0;
              height: 0;
            }

            .switch-label {
              position: relative;
              display: inline-block;
              width: 50px;
              height: 24px;
              cursor: pointer;

              .switch-slider {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #ccc;
                border-radius: 24px;
                transition: 0.3s;

                &:before {
                  position: absolute;
                  content: "";
                  height: 18px;
                  width: 18px;
                  left: 3px;
                  bottom: 3px;
                  background-color: white;
                  border-radius: 50%;
                  transition: 0.3s;
                }
              }
            }

            input:checked+.switch-label .switch-slider {
              background-color: #1ba5a4;
            }

            input:checked+.switch-label .switch-slider:before {
              transform: translateX(26px);
            }
          }

          .status-text {
            font-size: 12px;
            color: #6c757d;
            min-width: 60px;
            text-align: left;

            &.active {
              color: #1ba5a4;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

// Responsive design
@media (max-width: 768px) {
  .page-body-content {
    padding: 15px;

    .features-container {
      .features-header {
        padding: 15px 20px;

        .header-item h4 {
          font-size: 14px;
        }
      }

      .features-list {
        .feature-item {
          padding: 15px 20px;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;

          .feature-info {
            width: 100%;
          }

          .feature-controls {
            width: 100%;
            justify-content: space-between;

            .deactivate-text {
              min-width: auto;
            }

            .status-text {
              min-width: auto;
            }
          }
        }
      }
    }
  }
}
</style>
